import React from 'react';

import GalleryPageLayout from './GalleryPageLayout';
import GalleryCoverflowCarousel from './GalleryCoverflowCarousel';
import { CAMP_PHOTOS as PHOTOS } from './galleryRealData';

/* Blood Donation Camps — live gallery page on the 3D Coverflow design. */
const BloodDonationCamps = () => (
    <GalleryPageLayout
        title="Blood Donation Camps"
        introImage={process.env.PUBLIC_URL + "/images/about-v2/blood-donation-camps.jpg"}
        introImageAlt="A donor giving blood at a Life Saver Army camp"
        galleryKicker="Photo gallery"
        galleryHeading="Moments From Our Camps"
        kicker="Organised with hospitals, blood banks and local partners"
        heading="Inside Our Camps"
        lead="Each camp is a coordinated effort between Life Saver Army volunteers, blood bank teams and local partners; from setup at dawn to the last unit collected."
        metaTitle="Blood Donation Camps — Gallery | JJF India"
        metaDescription="Photo highlights from JJF India's blood donation camps, presented in an immersive 3D coverflow gallery."
    >
        <GalleryCoverflowCarousel photos={PHOTOS} />
    </GalleryPageLayout>
);

export default BloodDonationCamps;
